const action = (id, label, description, prompt, extra = {}) => ({
  id,
  label,
  description,
  prompt,
  supportsCompetencia: false,
  supportsStatus: false,
  ...extra,
});

export const CHAT_OPERACIONAL_STEPS = [
  {
    id: 'step-empresa',
    title: '1. Escolha a empresa',
    description: 'Pesquise por nome, razão social ou CNPJ para fixar o contexto da conversa.',
  },
  {
    id: 'step-acao',
    title: '2. Filtre o módulo',
    description: 'Refine o catálogo por módulo, competência e status antes de disparar a ação.',
  },
  {
    id: 'step-execucao',
    title: '3. Receba o resultado',
    description: 'A Mannu usa a mesma base do Hub e continua o fluxo até entregar consulta, documento ou tarefa.',
  },
];

export const CHAT_OPERACIONAL_MODULE_OPTIONS = [
  { value: 'all', label: 'Todos os módulos' },
  { value: 'empresa', label: 'Cadastro e empresa' },
  { value: 'fiscal', label: 'Fiscal e DAS' },
  { value: 'documentos', label: 'Documentos' },
  { value: 'tarefas', label: 'Tarefas' },
];

export const CHAT_OPERACIONAL_STATUS_OPTIONS = [
  { value: 'all', label: 'Todos os status' },
  { value: 'open', label: 'Em aberto / pendente' },
  { value: 'overdue', label: 'Atrasado / vencido' },
  { value: 'done', label: 'Concluído / regular' },
];

export const CHAT_OPERACIONAL_COMPETENCIA_OPTIONS = [
  { value: 'all', label: 'Sem filtro de competência' },
  { value: 'current', label: 'Mês atual' },
  { value: 'previous', label: 'Mês anterior' },
  { value: 'manual', label: 'Escolher mês' },
];

export const CHAT_OPERACIONAL_STATUS_PROMPTS = {
  open: 'Considere apenas itens em aberto, pendentes ou aguardando ação.',
  overdue: 'Considere apenas itens atrasados, vencidos ou irregulares.',
  done: 'Considere apenas itens concluídos, regularizados ou finalizados.',
};

export const MANNU_GUIDED_ACTION_CATEGORIES = [
  {
    id: 'empresa',
    title: 'Cadastro e empresa',
    description: 'Consultas cadastrais e visão administrativa da empresa ativa.',
    actions: [
      action('situacao-cnpj', 'Situação do CNPJ', 'Status, situação cadastral e dados principais.', 'Consulte a situação do CNPJ desta empresa e me traga um resumo objetivo.', { supportsStatus: true }),
      action('cadastro-completo', 'Cadastro completo', 'Razão social, nome fantasia, CNAE e natureza jurídica.', 'Quero um resumo cadastral completo desta empresa.', { supportsStatus: true }),
      action('inscricao-estadual', 'Inscrição estadual', 'Número, UF e status da IE.', 'Consulte a inscrição estadual desta empresa e me mostre número, UF e status.', { supportsStatus: true }),
      action('regime-tributario', 'Regime tributário', 'Regime atual e enquadramento da empresa.', 'Me diga o regime tributário e o enquadramento desta empresa.', { supportsStatus: true }),
      action('endereco', 'Endereço', 'Endereço cadastrado da empresa.', 'Mostre o endereço completo desta empresa.'),
      action('email', 'E-mail cadastrado', 'E-mail principal vinculado ao cadastro.', 'Me mostre o e-mail cadastrado desta empresa.'),
      action('socios', 'Sócios', 'Quadro societário e dados disponíveis.', 'Quero consultar os sócios desta empresa.'),
      action('certificado', 'Certificado digital', 'Validade e status do certificado.', 'Consulte o certificado digital desta empresa.', { supportsStatus: true }),
      action('cartao-cnpj', 'Cartão CNPJ', 'Emitir ou localizar o cartão CNPJ.', 'Preciso emitir o cartão CNPJ desta empresa.'),
    ],
  },
  {
    id: 'fiscal',
    title: 'Fiscal e DAS',
    description: 'Consultas fiscais com filtros por competência e situação.',
    actions: [
      action('consulta-fiscal', 'Consulta fiscal', 'Situação fiscal geral da empresa.', 'Faça uma consulta fiscal completa desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('consultar-das', 'Consultar DAS', 'Situação do DAS da competência desejada.', 'Quero consultar o DAS desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('gerar-das', 'Gerar DAS', 'Iniciar fluxo de emissão da guia DAS.', 'Quero gerar o DAS desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('guias-em-aberto', 'Guias em aberto', 'Listar guias pendentes dessa empresa.', 'Liste as guias em aberto desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('debitos', 'Débitos fiscais', 'Pendências e débitos em aberto.', 'Consulte os débitos fiscais desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('parcelamentos', 'Parcelamentos', 'Consultar parcelamentos e pedidos ativos.', 'Quero consultar os parcelamentos desta empresa.', { supportsStatus: true }),
      action('parcela-parcelamento', 'Parcela do parcelamento', 'Emitir ou localizar parcela específica.', 'Quero localizar ou emitir uma parcela de parcelamento desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('impostos-vencidos', 'Impostos vencidos', 'Guias e tributos em atraso.', 'Verifique os impostos vencidos desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('certidao', 'Emitir certidão', 'Escolher e iniciar emissão da certidão.', 'Quero emitir uma certidão para esta empresa.', { supportsStatus: true }),
      action('dctfweb', 'DCTFWeb / INSS', 'Consultar recibos, guias e documentos.', 'Quero consultar a DCTFWeb e INSS desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('fgts', 'FGTS', 'Consultar situação de FGTS.', 'Quero consultar o FGTS desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('esocial', 'eSocial', 'Consultar status e fechamento do eSocial.', 'Quero consultar o eSocial desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
    ],
  },
  {
    id: 'documentos',
    title: 'Documentos',
    description: 'Busca documental refinada por tipo, competência e situação.',
    actions: [
      action('ultimo-arquivo', 'Último arquivo', 'Trazer o documento mais recente.', 'Me mostre o último arquivo desta empresa.'),
      action('documentos-recentes', 'Documentos recentes', 'Lista os documentos mais novos.', 'Liste os documentos recentes desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('guias-documentos', 'Guias e comprovantes', 'Trazer guias, comprovantes ou recibos mais recentes.', 'Quero os documentos de guias e comprovantes desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('pgdas-documentos', 'PGDAS-D', 'Declaração, extrato ou recibo.', 'Quero consultar documentos do PGDAS-D desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('dctf-documentos', 'Recibos DCTFWeb', 'Recibos e documentos da DCTFWeb.', 'Me traga os recibos e documentos da DCTFWeb desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('certidoes-documentos', 'Certidões salvas', 'Buscar certidões emitidas no histórico.', 'Procure certidões salvas desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('validar-documentos', 'Validar documentos', 'Checa histórico e consistência documental.', 'Valide os documentos desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
    ],
  },
  {
    id: 'tarefas',
    title: 'Tarefas e operação',
    description: 'Operação diária da empresa ativa com recortes de status.',
    actions: [
      action('criar-tarefa', 'Criar tarefa', 'Abre o fluxo guiado de criação.', 'Quero criar uma tarefa para esta empresa.', { supportsStatus: true }),
      action('listar-tarefas', 'Tarefas da empresa', 'Lista tarefas abertas ou pendentes.', 'Liste as tarefas desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('tarefas-atrasadas', 'Tarefas atrasadas', 'Traz apenas o que está fora do prazo.', 'Liste as tarefas atrasadas desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('tarefas-concluidas', 'Tarefas concluídas', 'Mostra tarefas finalizadas.', 'Liste as tarefas concluídas desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
      action('verificar-pendencias', 'Verificar pendências', 'Resumo rápido de pendências e alertas.', 'Verifique as pendências desta empresa.', { supportsCompetencia: true, supportsStatus: true }),
    ],
  },
];